import { render } from "./RefreshView.vue?vue&type=template&id=3140b23c"
const script = {}

import exportComponent from "/Users/Ios/Documents/project/FrontEnd/qc/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__